// 授课形式

import React, { useEffect, useRef, useContext } from 'react';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { Pagination, Swiper as S } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from 'swiper/types';
// import { Swiper as SwiperClass } from 'swiper/types';
// import SwiperCore, { Pagination } from 'swiper/core';
// import SwiperClass from 'swiper/types/swiper-class';

import classNames from 'classnames';
import { PC, Mobile } from '@wukong/haomao';
// import { ISwiper, SwiperSlide } from '@/components/Swiper';
import { MyContext } from '../../../../config/context-manager';

import useIsMobile from '../../../../hooks/useIsMobile';
import Title from '../Title';
import styles from './style.module.scss';
// import 'swiper/swiper.min.css';
// import 'swiper/components/pagination/pagination.min.css';

import 'swiper/css';
import 'swiper/css/pagination';

S.use([Pagination]);

interface CardProps {
  imgUrl: string;
  title: string;
  content: string;
  imgW: number;
  imgH: number;
  theme?: 'red' | 'yellow' | 'blue';
  numImg: string;
}

const Card = ({ imgUrl, title, content, imgW, imgH, theme, numImg }: CardProps) => {
  const { locale } = useContext(MyContext);
  return (
    <div>
      <PC>
        <div>
          <div key={title} className={styles.skillCard}>
            <div className={styles.cardNum}>
              <Image src={numImg} layout="fill" alt="" />
            </div>
            <div className={styles.cardImg}>
              <Image src={imgUrl} width={imgW} height={imgH} alt="" />
            </div>
            <h4 className={styles.cardDesTitle}>{title}</h4>
          </div>

          <div className={styles.introduceContainer}>
            <ul dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      </PC>
      <Mobile>
        <div>
          <div className={classNames(styles.swiperCardBox, styles[`theme-${theme}`])}>
            {locale === 'zh' ? (
              <h4 className={styles.swiperCardTitle}>· {title} ·</h4>
            ) : (
              <h4 className={styles.swiperCardTitle}>{title}</h4>
            )}
            <div className={styles.swiperCardContent}>
              <div className={styles.iCardImg}>
                <Image src={imgUrl} layout="fill" objectFit="contain" priority alt="" />
              </div>
              <div className={styles.cardIntroduceContainer}>
                <ul dangerouslySetInnerHTML={{ __html: content }} />
              </div>
            </div>
          </div>
        </div>
      </Mobile>
    </div>
  );
};

const TeachingForm = () => {
  const { t } = useTranslation('chineseSpecialty');
  const { locale } = useContext(MyContext);

  const cardData: CardProps[] = [
    {
      imgUrl: '/images/chinese-math-class/chinese/specil/teaching-form-1v1.png',
      title: t('授课形式-类型-1'),
      content: t('授课形式-类型-1-内容'),
      imgW: 145,
      imgH: 124,
      theme: 'red',
      numImg: '/images/chinese-math-class/chinese/specil/teaching-form-num1.png',
    },
    {
      imgUrl: '/images/chinese-math-class/chinese/specil/teaching-form-class.png',
      title: t('授课形式-类型-2'),
      content: t('授课形式-类型-2-内容'),
      imgW: 229,
      imgH: 111,
      theme: 'yellow',
      numImg: '/images/chinese-math-class/chinese/specil/teaching-form-num2.png',
    },
    {
      imgUrl: '/images/chinese-math-class/chinese/specil/teaching-form-family.png',
      title: t('授课形式-类型-3'),
      content: t('授课形式-类型-3-内容'),
      imgW: 207,
      imgH: 139,
      theme: 'blue',
      numImg: '/images/chinese-math-class/chinese/specil/teaching-form-num3.png',
    },
  ];

  const isMobile = useIsMobile();

  const swiperRef = useRef<SwiperClass>();

  const handleSwiperInit = (swiper: SwiperClass) => {
    swiperRef.current = swiper;
  };

  useEffect(() => {
    if (isMobile) {
      swiperRef.current?.enable();
    } else {
      swiperRef.current?.disable();
    }
  }, [isMobile]);

  return (
    <section
      className={classNames(styles.container, {
        [styles.localeEn]: locale === 'en',
      })}
    >
      <PC>
        <div>
          <div className={styles.content}>
            <h3 className={styles.mainTitle}>{t('授课形式-主标题')}</h3>
            <div className={styles.skill}>
              <div className={styles.skillTitle}>
                <p className={styles.skillTitleText}>{t('授课形式-副标题')}</p>
                <div className={styles.borderContainer}>
                  <div className={styles.borderItem} />
                  <div className={`${styles.borderItem} ${styles.skillTitleBg}`}>
                    <span />
                  </div>
                  <div className={styles.borderItem} />
                </div>
              </div>
              <div className={styles.skillContent}>
                {cardData.map((item, index) => (
                  <Card
                    key={`${item.title}-${index}`}
                    imgUrl={item.imgUrl}
                    title={item.title}
                    content={item.content}
                    imgW={item.imgW}
                    imgH={item.imgH}
                    theme={item.theme}
                    numImg={item.numImg}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </PC>
      <Mobile>
        <div className={styles.content}>
          <Title>
            <p>{t('授课形式-主标题')} </p>
            <p>{t('授课形式-副标题')}</p>
          </Title>
          <Swiper
            className={styles.swiper}
            onInit={handleSwiperInit}
            enabled={isMobile}
            loop={isMobile}
            slidesPerView={1}
            // slidesPerColumn={1}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              '720': {
                slidesPerView: 3,
              },
            }}
          >
            {cardData.map((item, index) => (
              <SwiperSlide key={`${item.title}-${index}`}>
                <Card
                  imgUrl={item.imgUrl}
                  title={item.title}
                  content={item.content}
                  imgW={item.imgW}
                  imgH={item.imgH}
                  theme={item.theme}
                  numImg={item.numImg}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Mobile>
    </section>
  );
};

export default TeachingForm;
